import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import styles from './EditTRouteModal.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { TRoutePhotoUploader } from 'common/TRoutePhotoUploader'
import { intlOrgVisibility, intlUserVisibility } from 'lib/visibility'
import { Msg, featureNames, commonVerbs, commonNouns } from 'lib/localization'
import { gearActions, gearSelectors } from 'data/resources/gears'
import { tripActions } from 'data/resources/trips'
import { routeActions } from 'data/resources/routes'
import { FormattedMessage as T, injectIntl, defineMessages } from 'react-intl'

export const EDIT_TROUTE_MODAL = 'EDIT_TROUTE_MODAL'

const messages = defineMessages({
  none: {
    id: 'EditTRouteModal.none',
    defaultMessage: 'None'
  }
})

class _EditTRouteModal extends React.PureComponent {
  constructor (props) {
    super(props)
    const { troute } = props
    // coerce nulls to '' so that React doesn't
    // render uncontrolled form fields
    this.state = {
      title: troute.name || '',
      description: troute.description || '',
      visibility: troute.visibility,
      savePending: false,
      gearId: troute.gearId
    }
  }

  componentDidMount () {
    const { objectType, troute, refreshGear } = this.props
    if (objectType === 'trip') {
      refreshGear(troute.userId)
    }
  }

  onTitleChange = (e) => {
    this.setState({ title: e.target.value })
  }

  onDescriptionChange = (e) => {
    this.setState({ description: e.target.value })
  }

  onVisibilityChange = (e) => {
    this.setState({ visibility: parseInt(e.target.value, 10) })
  }

  onGearChange = (e) => {
    this.setState({ gearId: parseInt(e.target.value, 10) })
  }

  saveChanges = () => {
    const { updateTRoute, onRequestClose, objectType } = this.props
    const { title, description, visibility, savePending, gearId } = this.state
    if (savePending) { return }

    // only try to update gear for a Trip
    const gearUpdate = objectType === 'trip'
      ? { gearId: gearId === -1 ? null : gearId }
      : {}

    this.setState({ savePending: true })
    updateTRoute({
      name: title,
      description,
      visibility,
      ...gearUpdate
    }).then(() => {
      this.setState({ savePending: false }, onRequestClose)
    })
  }

  render () {
    const { onRequestClose, troute, objectType, userGear, intl } = this.props
    const { title, description, visibility, savePending, gearId } = this.state
    const visibilityMap = (troute.club ? intlOrgVisibility : intlUserVisibility)(intl)

    return (
      <ConfirmationDialog
        title={<Fragment><Msg capitalized m={commonVerbs.editing} /> <strong>{troute.name}</strong></Fragment>}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.saveChanges}
        confirmPending={savePending}
        confirmText={intl.formatMessage(commonVerbs.save)}
        footerHint={objectType === 'route'
          ? <a href={`/routes/${troute.id}/edit`} target='_blank'><T id='EditTRouteModal.editInPlanner' defaultMessage='Edit Route in Planner' /></a>
          : <a href={`/trips/${troute.id}/edit`}><T id='EditTRouteModal.moreOptions' defaultMessage='More Options' /></a>}>
        <div className={styles.EditTRouteModal}>
          <form onSubmit={e => { e.preventDefault(); this.saveChanges() }}>
            <div>
              <label htmlFor='title-input'><Msg capitalized m={commonNouns.title} /></label>
              <input id='title-input'
                type='text'
                value={title}
                onChange={this.onTitleChange} />
            </div>
            <div>
              <label htmlFor='description-input'><Msg capitalized m={commonNouns.description} /></label>
              <textarea id='description-input'
                rows='2'
                value={description}
                onChange={this.onDescriptionChange} />
            </div>
            <div>
              <label><Msg m={commonNouns.visibility} /></label>
              <select value={visibility} onChange={this.onVisibilityChange}>
                <option value='0'>{visibilityMap[0]}</option>
                <option value='1'>{visibilityMap[1]}</option>
                <option value='2'>{visibilityMap[2]}</option>
              </select>
            </div>
            {objectType === 'trip' && <div>
              <label><Msg m={featureNames.gear} /></label>
              <select value={gearId} onChange={this.onGearChange}>
                <option value={-1}>{intl.formatMessage(messages.none)}</option>
                {troute.gearId && <option value={troute.gearId}>{troute.gearName}</option>}
                {userGear.filter(g => g.id !== troute.gearId && !g.archived).map(g =>
                  <option value={g.id}>{g.name}</option>
                )}
              </select>
            </div>}
          </form>
          <TRoutePhotoUploader
            intl={intl}
            troute={troute}
            objectType={objectType} />
        </div>
      </ConfirmationDialog>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  userGear: gearSelectors.byUserId(state, ownProps.troute.userId)
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const actionCreator = ownProps.objectType === 'route'
    ? routeActions.update
    : tripActions.update
  return {
    updateTRoute: updates => dispatch(actionCreator(ownProps.troute.id, { [ownProps.objectType]: updates })),
    refreshGear: userId => dispatch(gearActions.list({ userId }))
  }
}

export const EditTRouteModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(_EditTRouteModal))
